import { IEvent } from "../../../../../../../common/services/cqs/event.service";

export class DestineringsraderUpdatedEvent implements IEvent {
    $type: string;
    arbetsorderId: number;
    antalRader: number;
    inaktivaDestineringar: number[];
    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "DestineringsraderUpdatedEvent";
    constructor(arbetsorderId: number, antalRader: number, inkativaDestineringar: number[]) {
        this.$type = DestineringsraderUpdatedEvent.type;
        this.arbetsorderId = arbetsorderId;
        this.antalRader = antalRader;
        this.inaktivaDestineringar = inkativaDestineringar;
    }
}
